import { NextRouter } from 'next/router';

export type Query = {
  query?: { firstLevelFilter?: string }
}

export interface Props {
  urlStr: string;
  router: NextRouter & Query;
  categoryLevelIsSecondOrHigher: boolean;
  withAdvertisementParamsOnly: boolean;
}
export interface Result {
  noIndexNoFollow?: boolean;
  noIndexAndFollow?: boolean;
  withCanonicalTag?: boolean;
  indexAndFollow?: boolean;
}

export const defineCategoriesRobotsAndCanonicalMode = (props: Props): Result => {
  const {
    urlStr,
    router,
    categoryLevelIsSecondOrHigher,
    withAdvertisementParamsOnly,
  } = props;

  const urlSplitted = urlStr.split('/?');
  const params = urlSplitted.length > 1
    ? urlSplitted[1].split('&').map(p => decodeURIComponent(p).split('=')[0])
    : [];


  /** @info do nothing if it's nth page */
  if (params.length === 1 && params[0].includes('page')) {
    return { withCanonicalTag: true };
  }

  if (!categoryLevelIsSecondOrHigher) {
    if (!params.length) {
      return { withCanonicalTag: true };
    }
    return { noIndexNoFollow: true, withCanonicalTag: true };
  }

  /** @info secondLevelCategory */

  const sortIsOnlyQueryParam = params.length === 1 && params[0] === 'sort';
  const onlyAdvertParams = withAdvertisementParamsOnly && params.length;

  if (sortIsOnlyQueryParam) {
    return { noIndexAndFollow: true };
  }

  if (onlyAdvertParams) {
    return { noIndexNoFollow: true, withCanonicalTag: true };
  }

  /** @info params are filters and there're more than 1 param */
  if (params.length) {
    return { noIndexNoFollow: true, withCanonicalTag: true };
  }
  if (!router.query.firstLevelFilter) {
    return { indexAndFollow: true, withCanonicalTag: true };
  }

  const firstParamAsAPartOfUrl = router.query.firstLevelFilter.split('=')[0];
  const withOnlyAllowedParam = !!firstParamAsAPartOfUrl;

  return withOnlyAllowedParam
    ? { indexAndFollow: true, withCanonicalTag: true }
    : { noIndexNoFollow: true, withCanonicalTag: true };
};
